import React, { Component } from 'react';
import styled from 'styled-components';

import { GREY, PRIMARY, WHITE } from '../constants/colors';

const ListWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  border: 1px solid ${GREY};
  padding: 7px;
  cursor: pointer;

  > span {
    text-align: center;
    flex-basis: 20%;
    max-widrh: 200px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  ${(props) => !props.header && `
    &: hover {
      background-color: ${PRIMARY};
      color: ${WHITE};
      border-color: ${PRIMARY};
    }
    `}
`;

export class ListItem extends Component {
  render() {
    const {
      children, columns, onSelect, header = false,
    } = this.props;

    return (
      <ListWrapper
        header={header}
        id={`${children.id}`}
        onClick={onSelect}
      >
        {columns.map((key, i) => (
          <span
            id={`${children.id}`}
            key={`${key}-${i}-${Date.now()}`}
          >
            {`${children[key]}`}
          </span>
        ))}
      </ListWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ListItem.js